import funcion from './funcion/siseva'

const funciones = {
  funcion: funcion
}

export default funciones;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/siseva/sisevaapi.js
// module id = null
// module chunks = 